import React, { useState } from 'react'
import Select, { components } from 'react-select';


function MultiSelectDropdown({ onChangeDropdown, Options, showLabel, selectedValue = [], placeholder }) {
    const [selectedOption, setSelectedOption] = useState([]);
    const [optionChanged, setOptionChanged] = useState(false);

    function handleChange(e, actionMeta) {
        setSelectedOption(e);
        setOptionChanged(true);
        onChangeDropdown(e, actionMeta);
    };

    // Custom Value Container: override default tag rendering
    const CustomValueContainer = ({ children, ...props }) => {
        const selected = props.getValue();
        const selectedCount = props.getValue().length;
        const totalCount = Options.length;

        if (selectedCount > 2) {
            const tooltip = selected.map(option => option.label).join(', ');
            return (
                <components.ValueContainer {...props}>
                <div title={tooltip} style={{ paddingLeft: 5 }}>{`${selectedCount} of ${totalCount} selected`}</div>
                </components.ValueContainer>
            );
        }

        return (
            <components.ValueContainer {...props}>
                {children}
            </components.ValueContainer>
        );
    };

    return (
        <>
            <Select
                name="StatusId"
                isMulti
                value={selectedValue}
                isClearable={true}
                options={Options || []}
                onChange={onChangeDropdown}
                menuPlacement="auto"
                menuPortalTarget={document.body}
                menuPosition="fixed"
                components={{ ValueContainer: CustomValueContainer }}
                placeholder={placeholder}
                styles={{
                    container: (base) => ({
                        ...base,
                        width: '275px', // Set container width
                    }),
                    menuPortal: base => ({ ...base, zIndex: 9999 })  // ensure it's above table
                }}
            />
        </>
    )
}

export default MultiSelectDropdown